'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OneOffNotification = exports.Notification = exports.Modal = exports.Shade = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n    background: ', ';\n    border-radius: ', ';\n    box-shadow: ', ';\n    z-index: 15;\n    padding: 1em;\n    margin: 0 1em;\n    width: 100%;\n    max-width: 600px; \n    max-height: 90vh;\n    overflow: scroll;\n    h2 {\n        margin-bottom: .5em;\n    }\n'], ['\n    background: ', ';\n    border-radius: ', ';\n    box-shadow: ', ';\n    z-index: 15;\n    padding: 1em;\n    margin: 0 1em;\n    width: 100%;\n    max-width: 600px; \n    max-height: 90vh;\n    overflow: scroll;\n    h2 {\n        margin-bottom: .5em;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    position: fixed;\n    z-index: 11;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background: rgba(0.3, 0.3, 0.3, 0.3);\n'], ['\n    position: fixed;\n    z-index: 11;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background: rgba(0.3, 0.3, 0.3, 0.3);\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex; \n    place-items: center;\n    justify-content: center;\n    align-items: center;\n    position: fixed; \n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 45;\n'], ['\n    display: flex; \n    place-items: center;\n    justify-content: center;\n    align-items: center;\n    position: fixed; \n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 45;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n    svg {\n            margin-top: .25em;\n    }\n    svg path {\n            fill: ', ';\n    }\n    h2 {\n        display: inline-block;\n        margin-left: ', ';\n        align-self: center;\n    }\n'], ['\n    display: flex;\n    svg {\n            margin-top: .25em;\n    }\n    svg path {\n            fill: ', ';\n    }\n    h2 {\n        display: inline-block;\n        margin-left: ', ';\n        align-self: center;\n    }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    margin-bottom: 1em;\n    padding: 1em;\n    border-radius: ', ';\n    background: ', ';\n    font-weight: bold;\n    color: #333;\n    ', '\n'], ['\n    margin-bottom: 1em;\n    padding: 1em;\n    border-radius: ', ';\n    background: ', ';\n    font-weight: bold;\n    color: #333;\n    ', '\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    border: none;\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    position: absolute;\n    top: -7.5px;\n    left: -7.5px;\n    background: red;\n    background: ', ';\n    color: ', ';\n    box-shadow: ', ';\n    font-weight: 500;\n    &:hover::after{\n            transform: scaleX(1);\n    }\n    &::before{\n            content: \'\';\n        width: 25px;\n        height: 25px;\n        position: absolute;\n        top: -5px;\n        left: -5px;\n        :hover{\n            border: .1rem solid;\n        }\n    }\n    ', '\n'], ['\n    border: none;\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    position: absolute;\n    top: -7.5px;\n    left: -7.5px;\n    background: red;\n    background: ', ';\n    color: ', ';\n    box-shadow: ', ';\n    font-weight: 500;\n    &:hover::after{\n            transform: scaleX(1);\n    }\n    &::before{\n            content: \'\';\n        width: 25px;\n        height: 25px;\n        position: absolute;\n        top: -5px;\n        left: -5px;\n        :hover{\n            border: .1rem solid;\n        }\n    }\n    ', '\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    position: fixed;\n    bottom: 1em;\n    left: 0;\n    left: 50%;\n    transform: translate(-50%, 0);\n    width: calc(100% - 2em);\n    max-width: 700px;\n    min-height: 50px;\n    border-radius: ', ';\n    background: ', ';\n    box-shadow: ', ';\n    border: .1rem solid ', ';\n    color: ', ';\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-direction: column;\n    padding: 1em;\n    z-index: 50;\n    p {\n            font - size: 80%;\n    }\n'], ['\n    position: fixed;\n    bottom: 1em;\n    left: 0;\n    left: 50%;\n    transform: translate(-50%, 0);\n    width: calc(100% - 2em);\n    max-width: 700px;\n    min-height: 50px;\n    border-radius: ', ';\n    background: ', ';\n    box-shadow: ', ';\n    border: .1rem solid ', ';\n    color: ', ';\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-direction: column;\n    padding: 1em;\n    z-index: 50;\n    p {\n            font - size: 80%;\n    }\n']);

exports.ToastItem = ToastItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _framerMotion = require('framer-motion');

var _buttons = require('../components/buttons');

var _icons = require('../components/icons');

var _hooks = require('../hooks');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ModalStyles = (0, _styledComponents2.default)(_framerMotion.motion.div)(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.foreground;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadow;
});

var Shade = exports.Shade = _styledComponents2.default.div(_templateObject2);

var Container = _styledComponents2.default.div(_templateObject3);

var Modal = exports.Modal = function Modal(_ref4) {
  var children = _ref4.children,
      isVisible = _ref4.isVisible,
      title = _ref4.title,
      shade = _ref4.shade,
      _ref4$close = _ref4.close,
      close = _ref4$close === undefined ? false : _ref4$close,
      style = _ref4.style; // console.log("close ", !!close())

  return _react2.default.createElement(_framerMotion.AnimatePresence, null, isVisible && _react2.default.createElement(Container, null, isVisible && shade && _react2.default.createElement(Shade, {
    onClick: close
  }), _react2.default.createElement(ModalStyles, {
    initial: {
      opacity: 0,
      y: 50
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: 50
    },
    style: style
  }, _react2.default.createElement(ModalHeader, {
    hasClose: !!close
  }, !!close && _react2.default.createElement('div', {
    onClick: close
  }, _react2.default.createElement(_icons.Cross, {
    faint: true
  })), title && _react2.default.createElement('h2', null, title)), children)));
};

var ModalHeader = _styledComponents2.default.div(_templateObject4, function (_ref5) {
  var theme = _ref5.theme;
  return theme.textColor;
}, function (_ref6) {
  var hasClose = _ref6.hasClose;
  return hasClose ? '.5em' : '0';
});

var ToastItemStyle = (0, _styledComponents2.default)(_framerMotion.motion.figure)(_templateObject5, function (_ref7) {
  var theme = _ref7.theme;
  return theme.borderRadius;
}, function (_ref8) {
  var theme = _ref8.theme,
      type = _ref8.type;
  return theme.stateColors[type];
}, function (_ref9) {
  var type = _ref9.type;
  return type === 'negative' && '\n        color: whitesmoke;\n    ';
});

function ToastItem(props) {
  return _react2.default.createElement(ToastItemStyle, {
    type: props.appearance,
    initial: {
      opacity: 0,
      x: 100
    },
    animate: {
      opacity: 1,
      x: 0
    },
    exit: {
      opacity: 0,
      x: -100
    }
  }, props.children);
}

var Notification = exports.Notification = _styledComponents2.default.div(_templateObject6, function (_ref10) {
  var theme = _ref10.theme,
      type = _ref10.type;
  return theme.stateColors[type];
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.textColor;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.shadow;
}, function (_ref13) {
  var message = _ref13.message,
      theme = _ref13.theme,
      type = _ref13.type;
  return !!message && '\n            &::after{\n                content: \'' + message + '\';\n                position: absolute; \n                border-radius: ' + theme.borderRadius + ';\n                color: ' + theme.textColor + ';\n                background: ' + theme.stateColors[type] + ';\n                height: 25px; \n                width: auto;\n                white-space: nowrap;\n                top: -12.5px;\n                left: 20px;\n                padding: .5em;\n                transform-origin: left;\n                transform: scaleX(0);\n                transition: .1s ease-out;\n            }\n        ';
});

var CookiesNotification = _styledComponents2.default.div(_templateObject7, function (_ref14) {
  var theme = _ref14.theme;
  return theme.borderRadius;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.background;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.shadow;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.brandColor;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.textColor;
});

var OneOffNotification = exports.OneOffNotification = function OneOffNotification(_ref19) {
  var children = _ref19.children,
      name = _ref19.name;

  var _useLocalStorage = (0, _hooks.useLocalStorage)(name),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      value = _useLocalStorage2[0],
      setValue = _useLocalStorage2[1];

  return !value && _reactDom2.default.createPortal(_react2.default.createElement(_framerMotion.AnimatePresence, null, _react2.default.createElement(CookiesNotification, null, _react2.default.createElement('div', {
    className: 'content'
  }, children), _react2.default.createElement('div', {
    style: {
      marginTop: '1em'
    }
  }, _react2.default.createElement(_buttons.PrimaryBtn, {
    onClick: function onClick() {
      return setValue(true);
    }
  }, 'No Problem')))), document.body);
};